import DocumentFormatPattern from '@/domain/models/document-format-pattern-model'
import { IMask } from 'react-imask'
import PatternRegex from './pattern-regex'
import { applyHiddenMask } from '@/domain/models/data-format-pattern-model'

const DocumentCnpjFormatPattern: DocumentFormatPattern<string> = {
  normalize: (value: string) => PatternRegex.getOnlyNumbers(value),
  placeholder: '00.000.000/0000-00',
  mask: '`a{.}`b{.}`c{/}`d{-}`e',
  hiddenMask: '00.0\\*\\*.\\*\\*\\*/\\*\\*\\*\\*-00',
  hide: (value: string) =>
    applyHiddenMask(
      value?.substring(0, 3) + value?.at(-2) + value?.at(-1),
      DocumentCnpjFormatPattern.hiddenMask!
    ),
  blocks: {
    a: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 99,
      maxLength: 2
    },
    b: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 999,
      maxLength: 3
    },
    c: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 999,
      maxLength: 3
    },
    d: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 9999,
      maxLength: 4
    },
    e: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 99,
      maxLength: 2
    }
  },
  isValid: (value?: string): boolean => {
    return DocumentCnpjFormatPattern.validate?.(value) === true
  },
  validate: (value?: string): boolean => {
    if (!value) return false
    const numbers = PatternRegex.getOnlyNumbers(value)
    return numbers.length === 14
  },
  rules: {
    minLength: {
      value: 18,
      message: 'Insira exatos 18 caracteres neste campo'
    },
    maxLength: {
      value: 18,
      message: 'Insira exatos 18 caracteres neste campo'
    }
  }
}

export default DocumentCnpjFormatPattern
